<template>
<div>



<section class="hero ls-main-hero" style="z-index:100">
    <div class="hero-head">
        <truenav />
    </div>

    <div class="hero-body">

        <br>
        <br>
        <br>


<div class="container has-text-centered ">

      <p class="title has-text-white">
        Get Started Today.
      </p>
      <p class="subtitle has-text-white">
        Free trial. No credit card required.
      </p>
    


    <section class="section" style="padding-top: 0;">

<div class="pricing-table">
  <div class="pricing-plan is-warning">
    <div class="plan-header">Free Trial</div>
    <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>0</span>/month</div>
    <div class="plan-items">
      <div class="plan-item">Unlimited Previews</div>
      <div class="plan-item" >Generate <b>50</b> docs  <br> <b>maximum</b></div>
      <!-- <div class="plan-item"><span style="color:red;font-size:1em;margin-bottom:2px">🗙</span> Create Your Own Templates</div> -->
      <!--<div class="plan-item"><span style="color:red;font-size:1em;margin-bottom:2px">❌</span> Create Your Own Templates</div> -->
      <div class="plan-item">Templates limit</div>
      <div class="plan-item">-</div>
    </div>
    <div class="plan-footer">
       <a href="https://app.minutemerge.com/signup" class="button is-fullwidth">Get Started</a>
    </div>
  </div>

  <div class="pricing-plan is-primary ">
    <div class="plan-header">Starter</div>
    <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>29</span>/month</div>
    <div class="plan-items">
      <div class="plan-item">Unlimited Previews</div>
      <div class="plan-item">Generate <b>1,000</b> docs <br> per month</div>
      <div class="plan-item">Unlimited Templates</div>
      <div class="plan-item">-</div>
    </div>
    <div class="plan-footer">
       <a href="https://app.minutemerge.com/signup" class="button is-fullwidth">Get Started</a>
    </div>
  </div>

  <div class="pricing-plan  is-primary">
    <div class="plan-header">Professional</div>
    <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>79</span>/month</div>
    <div class="plan-items">
      <div class="plan-item">Unlimited Previews</div>
      <div class="plan-item">Generate <b>5,000</b> docs <br> per month</div>
      <div class="plan-item">Unlimited Templates</div>
      <div class="plan-item">-</div>
    </div>
    <div class="plan-footer">
       <a href="https://app.minutemerge.com/signup" class="button is-fullwidth">Get Started</a>
    </div>
  </div>

  <div class="pricing-plan is-primary">
    <div class="plan-header">Enterprise</div>
    <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>129</span>/month</div>
    <div class="plan-items">
      <div class="plan-item">Unlimited Previews</div>
      <div class="plan-item">Generate <b>25,000</b> docs <br> per month</div>
      <div class="plan-item">Unlimited Templates</div>
      <div class="plan-item">Priority Support</div>
    </div>
    <div class="plan-footer">
      <a href="https://app.minutemerge.com/signup" class="button is-fullwidth">Get Started</a>
    </div>
  </div>
  
</div>

 </section>
 </div>
    </div>




</section>



<!--<section class="section ls-hero-image">
    <div class="container">
        <div class="columns">
            <div class="column is-8-desktop is-offset-2-desktop">
                <div class="ls-section-content has-text-centered">
                    <h3 class="title has-text-dark">Are you still creating documents manually?</h3>
                    <p class="content has-text-grey is-size-5">
                        Capitalize on low hanging fruit to identify a ballpark value added activity to beta test.
                        Override the digital divide with additional clickthroughs.
                    </p>
<iframe style="width:560px ; height:315px" width="560" height="315" src="https://www.youtube.com/embed/OExHVQ9CRCw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>               
</div>
            </div>
        </div>        
    </div>
</section>-->

<!--
<section class="section has-background-primary ls-hero-image">
    <div class="container">
        <div class="columns">
            <div class="column is-5 has-text-white">
                <h4 class="title is-3 has-text-white">Personalize Docs & Pictures</h4>
                <div class="content">
                    <p>Pellentesque dictum purus leo, et placerat turpis porta gravida. In cursus diam id ipsum vulputate, ut
                       venenatis eros porta. Aenean fringilla a nisi ac viverra.</p>
                    <p>Curabitur sagittis sit amet quam at rhoncus. Ut sed consequat ex, sed consequat ipsum. Pellentesque nec
                       nisi justo.</p>
                </div>
                <a class="button has-text-weight-bold ls-button is-success">Download Theme</a>
            </div>
            <div class="column is-8">
                <figure class="image">
               <img src="../img/hero-image.png" srcset="../img/hero-image@2x.png 320w, ../img/hero-image@3x.png 400w, ../img/hero-image@3x.png 1024w" title="LandSpeed Example" width="861" height="564">
                </figure>
            </div>
        </div>
    </div>
</section>
-->


<!--
<section class="section ls-cards-grid">
    <div class="container">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <div class="ls-section-content has-text-centered">
                    <h3 class="title has-text-dark">Connect your favorite apps</h3>
                    <p class="content has-text-grey is-size-5">
                        Pellentesque dictum purus leo, et placerat turpis porta gravida. In cursus diam id ipsum vulputate, ut
                        venenatis eros porta. Aenean fringilla a nisi ac viverra.
                    </p>
                </div>
            </div>
        </div>

        <div class="columns is-multiline is-mobile">

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/card-1.png" srcset="../img/card-1@2x.png 320w, ../img/card-1@3x.png 400w, ../img/card-1@3x.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a class="button is-black">Download</a>
                            <a class="button is-black">View Demo</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Internet Curated</a>
                            <p>European minnow priapumfish mosshead
                               warbonnet shrimpfish . Cutlassfish porbeagle shark
                               ricefish walking.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/card-2.png" srcset="../img/card-2@2x.png 320w, ../img/card-2@3x.png 400w, ../img/card-2@3x.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a class="button is-black">Download</a>
                            <a class="button is-black">View Demo</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Internet Curated</a>
                            <p>European minnow priapumfish mosshead
                               warbonnet shrimpfish . Cutlassfish porbeagle shark
                               ricefish walking.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/card-3.png" srcset="../img/card-3@2x.png 320w, ../img/card-3@3x.png 400w, ../img/card-3@3x.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a class="button is-black">Download</a>
                            <a class="button is-black">View Demo</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Internet Curated</a>
                            <p>European minnow priapumfish mosshead
                               warbonnet shrimpfish . Cutlassfish porbeagle shark
                               ricefish walking.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/card-4.png" srcset="../img/card-4@2x.png 320w, ../img/card-4@3x.png 400w, ../img/card-4@3x.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a class="button is-black">Download</a>
                            <a class="button is-black">View Demo</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Internet Curated</a>
                            <p>European minnow priapumfish mosshead
                               warbonnet shrimpfish . Cutlassfish porbeagle shark
                               ricefish walking.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/card-5.png" srcset="../img/card-5@2x.png 320w, ../img/card-5@3x.png 400w, ../img/card-5@3x.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a class="button is-black">Download</a>
                            <a class="button is-black">View Demo</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Internet Curated</a>
                            <p>European minnow priapumfish mosshead
                               warbonnet shrimpfish . Cutlassfish porbeagle shark
                               ricefish walking.</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column is-one-third-desktop is-half-tablet is-full-mobile">
                <article class="card ls-card">
                    <div class="card-image">
                        <figure class="image">
                            <img src="../img/card-6.png" srcset="../img/card-6@2x.png 320w, ../img/card-6@3x.png 400w, ../img/card-6@3x.png 1024w" title="Card Placeholder" width="360" height="217">
                        </figure>
                        <div class="buttons">
                            <a class="button is-black">Download</a>
                            <a class="button is-black">View Demo</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <a href="/" class="title has-text-weight-bold is-5 has-text-dark">Internet Curated</a>
                            <p>European minnow priapumfish mosshead
                               warbonnet shrimpfish . Cutlassfish porbeagle shark
                               ricefish walking.</p>
                        </div>
                    </div>
                </article>
            </div>

        </div>
    </div>
</section>-->



<!--
<section class="section ls-background-light">
    <div class="container">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <div class="ls-section-content has-text-centered">
                    <h3 class="title has-text-dark">Showcase</h3>
                    <p class="content has-text-grey has-text-weight-light is-size-5">
                        Capitalize on low hanging fruit to identify a ballpark value added activity to beta test.
                        Override the digital divide with additional clickthroughs.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>-->


<!--
<section class="section">
    <div class="container">
        <div class="columns">
            <div class="column is-8-desktop is-offset-2-desktop">
                <div class="ls-section-content has-text-centered ls-space-bottom">
                    <h3 class="title has-text-dark">Contact Us</h3>
                    <p class="content has-text-grey is-size-5">
                        Capitalize on low hanging fruit to identify a ballpark value added activity to beta test.
                        Override the digital divide with additional clickthroughs.
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            
            <div class="column is-7">
                <form action="" class="ls-form-contact">
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <p class="control is-expanded">
                                    <label class="screen-reader-text" for="lsNameInput">Your Name</label>
                                    <input class="input" id="lsNameInput" type="text" placeholder="Name">
                                </p>
                            </div>
                            <div class="field">
                                <p class="control is-expanded">
                                    <label class="screen-reader-text" for="lsEmailInput">Your Email</label>
                                    <input class="input" id="lsEmailInput" type="email" placeholder="Email" value="">
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <label class="screen-reader-text">Message</label>
                                    <textarea class="textarea" placeholder="Message"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <button class="button ls-button-slim has-text-weight-bold is-success">
                                        Send message
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
            <div class="column is-5 ls-info-contact">
                <h4 class="title is-5 has-text-dark ls-half-space">Get in Touch</h4>
                <p class="content has-text-grey">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur totam aliquid porro natus libero, ipsa.
                </p>

                <div class="media ls-item-contact">
                    <div class="media-left">
                        <span class="icon has-text-primary fa-lg">
                            <i aria-hidden="true" class="fas fa-envelope"></i>
                        </span>
                    </div>
                    <a href="#" class="">Email: email@yourmail.com</a>
                </div>
                <div class="media ls-item-contact">
                    <div class="media-left">
                        <span class="icon has-text-primary fa-lg">
                      <i aria-hidden="true" class="fas fa-phone" data-fa-transform="rotate-90"></i>
                    </span>
                    </div>
                    <a href="#" class="">Phone: +123 456 789</a>
                </div>
                <div class="media ls-item-contact">
                    <div class="media-left">
                        <span class="icon has-text-primary fa-lg">
                          <i aria-hidden="true" class="fas fa-globe"></i>
                        </span>
                    </div>
                    <a href="#">Web: www.yoursite.com</a>
                </div>

                <div class="ls-social-buttons">
                    <h4 class="title has-text-dark is-6 is-marginless ls-half-space">Get in Touch</h4>
                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-facebook">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-facebook-f" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-twitter">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-twitter" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-instagram">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-instagram" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-google-plus">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-google-plus-g" data-fa-transform="shrink-10 left-1.2"></i>
                        </span>
                    </a>

                    <a href="#" rel="noopener" class="icon ls-social-icon fa-3x ls-pinterest">
                        <span class="fa-layers fa-fw">
                            <i class="fas fa-square"></i>
                            <i class="fa-inverse fab fa-pinterest-p" data-fa-transform="shrink-10"></i>
                        </span>
                    </a>

                </div>
            </div>
        </div>
    </div>
</section>
-->


<!-- <section class="section ls-rainbow-gradient">
    <div class="container">
        <div class="columns">
            <div class="column is-4">
                <h3 class="title ls-half-space has-text-white is-3 has-text-bold">Subscribe To Our Newsletter </h3>
                <p class="has-text-white">Never miss our latest <b>tips</b> & <b>tutorials!</b></p>
            </div>
            <div class="column is-5 is-offset-2">
                <div class="field ls-round-input has-background-white">
                    <input class="input has-text-grey" type="text" placeholder="Enter Your Email">
                    <button type="submit" class="button is-success">
                        Subscribe
                    </button>
                </div>
            </div>
        </div>
    </div>
</section> -->




</div>
</template>

<script>
//require("../js/main.js") 
require("../../css/main.css") 
//import firebase from "firebase/app";
import truenav from "../components/truenav";


export default {
  components: {
      truenav

  },
  data () {
    return {
        
  }
},

watch:{
//user: function() {  if (this.user) { this.$router.push('/templates') }
//else {}
//}
},
created: function () {
  
//document.getElementsByTagName('html')[0].style.background = "white"
},
mounted: function() {
//this.$router.push('/templates')
// /return this.$store.state.user.user
},

methods:{

}


}
</script>






<style>

</style>
